<template>
    <div>
        <div class="dx-field dx-field-left">
            <div class="dx-field-label dx-field-label-left">Наличие ЭЦП</div>
            <div class="dx-field-value dx-field-value-left">
                <dx-check-box :value="data?.ecp" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxCheckBox } from 'devextreme-vue';

const data = inject('data');
</script>
